import React from "react";
import { useFormikContext } from "formik";
import { Grid, TextField, Switch, FormControlLabel } from "@material-ui/core";
import SectionCard from "./SectionCard";

const SubAgentReservation: React.FC = () => {
  const { values, handleChange, setFieldValue } = useFormikContext<any>();

  return (
    <SectionCard title="Reservation limits">
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField type="number" fullWidth name="maxAdultAllowed" label="Max Adult" value={values.maxAdultAllowed ?? 0} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField type="number" fullWidth name="maxChildAllowed" label="Max Child" value={values.maxChildAllowed ?? 0} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField type="number" fullWidth name="maxInfantAllowed" label="Max Infant" value={values.maxInfantAllowed ?? 0} onChange={handleChange} />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={!!values.allowInfantOnly}
                onChange={(_, v) => setFieldValue("allowInfantOnly", v)}
                color="primary"
              />
            }
            label="Allow infant only"
          />
        </Grid>
      </Grid>
    </SectionCard>
  );
};

export default SubAgentReservation;
